/**
 * Grupo abierto en la barra lateral clásica tras pulsar `id`.
 * Pulsar el grupo abierto lo cierra; restaurar el grupo anotado (`soloAbrir`)
 * lo deja abierto aunque la carga ya lo haya abierto por default.
 */
export function grupoAbiertoTrasPulsar(
  actual: number | null,
  id: number,
  soloAbrir = false,
): number | null {
  if (soloAbrir) return id;
  return actual === id ? null : id;
}
